/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/no-empty-interface */
import { IProductSearchParams } from "./product.interface";

// Tabla de búsqueda para mensajes
export const MESSAGE_LOOKUP: Record<string, Record<'origin' | 'destination' | 'default', string>> = {
  airport: {
    origin: 'Arribo del vuelo',
    destination: 'Salida del vuelo',
    default: 'Hora del pickup'
  },
  hotel: {
    origin: 'Hora del pickup',
    destination: 'Hora del pickup',
    default: 'Hora del pickup'
  },
  city: {
    origin: 'Hora del pickup',
    destination: 'Hora del pickup',
    default: 'Hora del pickup'
  },
  port: {
    origin: 'LLegada embarque',
    destination: 'Hora del embarque',
    default: 'Hora del pickup'
  },
  train: {
    origin: 'Hora de llegada',
    destination: 'Hora de salida',
    default: 'Hora del pickup'
  },
  bus: {
    origin: 'Hora de llegada',
    destination: 'Hora de salida',
    default: 'Hora del pickup'
  },
  restaurant: {
    origin: 'Hora del pickup',
    destination: 'Hora fin salida',
    default: 'Hora del pickup'
  },
  attraction: {
    origin: 'Hora del pickup',
    destination: 'Hora fin visita',
    default: 'Hora del pickup'
  }
};

export interface payloadTransport extends IProductSearchParams {
  readonly market: number;

}

export type TransportLocationType = keyof typeof MESSAGE_LOOKUP;

export interface ITransportPickupLocation {
  id: number;
  name: string;
  address: string;
  latitude: string;
  longitude: string;
  type: TransportLocationType;
  origin: string;
  originDateTransfers: TransportLocationType;
}

export interface ITransportDropoffLocation {
  id: number;
  name: string;
  address: string;
  latitude: string;
  longitude: string;
  type: TransportLocationType;
  destination: string;
  originDateTransfers: TransportLocationType;
}

export interface ITransportPaxList {
  adults: number;
  children: number[];
}

export interface ITransportTransfers {
  pickupLocation: ITransportPickupLocation;
  dropoffLocation: ITransportDropoffLocation;
  pickupTime: string | null;
  dropoffTime: string | null;
  oneWay: boolean;
  rideHailing: boolean;
  paxList: ITransportPaxList;
}

export interface ITransportSearchPayload {
  providersId: [] | null;
  categoriesId: number[];
  pickupDate: string;
  dropoffDate: string | null;
  market: number;
  oldReservationId: number | null;
  transfers: ITransportTransfers;
}

export interface IResolvedLocation {
  id: number;
  name: string;
  type: TransportLocationType | null;
}

/**
 * Resuelve id/name/type de una entrada cruda de `searchlocations` (airports/hotels/cities/...).
 * `city` es el único caso que no trae `name`, sino `city_name`.
 * Si falta id o name, corta el flujo (devuelve null) y avisa por console.warn.
 */
export const resolveLocationOption = (entry: any, type?: TransportLocationType): IResolvedLocation | null => {
  const name = entry?.name ?? entry?.city_name;
  const id = entry?.id;

  if (id == null || !name) {
    console.warn('[resolveLocationOption] Falta id o name en la ubicación:', entry);
    return null;
  }

  return { id, name, type: type ?? null };
};
